export default __webpack_public_path__ + "static/media/link.f1018dc9.svg";